import {uploadRefStart, uploadStart} from '../services/upload'

let OSS = require('ali-oss')
let Base64 = require('js-base64').Base64

function AliOssUpload (objName, localfile, progress) {
  this.videoId = 0
  this.objName = objName
  this.uploadAuth = ''
  this.uploadAddress = ''
  this.uploadcount = 0

  this.startUpload = function () {
    if (!this.videoId) {
      return uploadStart(this.objName).then(res => {
        let data = res.data
        this.uploadAuth = JSON.parse(Base64.decode(data.uploadauth))
        this.uploadAddress = JSON.parse(Base64.decode(data.uploadaddress))
        this.videoId = data.videoid
        return this.multipartUpload()
      })
    } else {
      return uploadRefStart(this.videoId).then(res => {
        let data = res.data
        this.uploadAuth = JSON.parse(Base64.decode(data.uploadauth))
        this.uploadAddress = JSON.parse(Base64.decode(data.uploadaddress))
        this.videoId = data.videoid
        return this.multipartUpload()
      })
    }
  }

  this.multipartUpload = async function () {
    try {
      var client = new OSS({
        endpoint: this.uploadAddress.Endpoint,
        region: this.uploadAuth.Region,
        accessKeyId: this.uploadAuth.AccessKeyId,
        accessKeySecret: this.uploadAuth.AccessKeySecret,
        bucket: this.uploadAddress.Bucket,
        stsToken: this.uploadAuth.SecurityToken
      })
      let result = await client.multipartUpload(this.uploadAddress.FileName, localfile, {
        progress: progress
      })
      let resultinfo = {
        localfile: localfile,
        videoId: this.videoId,
        res: result.res
      }
      return new Promise((resolve, reject) => {
        resolve(resultinfo)
      })
    } catch (e) {
      // 捕获超时异常
      if (e.code === 'ConnectionTimeoutError') {
        // do ConnectionTimeoutError operation
        if (this.uploadcount < 3) {
          this.startUpload()
          this.uploadcount++
        }
      }
    }
  }

  this.stopUpload = function () {

  }
}

export default {AliOssUpload}
